import { Center } from '@/types/models'

type NavigationLinkLabel =
  | 'About'
  | 'Treatment'
  | 'Amenities'
  | 'Staff'
  | 'Reviews'
  | 'FAQs'
  | 'Insurance'
type NavigationLinkId =
  | 'profile-about'
  | 'profile-treatment'
  | 'profile-treatments'
  | 'profile-amenities'
  | 'profile-reviews'
  | 'profile-faqs'
  | 'profile-insurance'
  | 'profile-staff'

type NavigationLink = {
  label: NavigationLinkLabel
  sectionId: NavigationLinkId
}

interface GeneratePremiumProfileNavigationLinksOptions {
  (props: {
    data?: Center
    showInsuranceInformation?: boolean
    showStaff?: boolean
  }): NavigationLink[]
}

const generatePremiumProfileNavigationLinks: GeneratePremiumProfileNavigationLinksOptions =
  ({ data, showInsuranceInformation = false, showStaff = false }) => {
    return [
      {
        label: 'About',
        sectionId: 'profile-about'
      },
      showInsuranceInformation && {
        label: 'Insurance',
        sectionId: 'profile-insurance'
      },
      {
        label: 'Treatment',
        sectionId:
          data?.text_picture && data.text_picture.length > 0
            ? 'profile-treatment'
            : 'profile-treatments'
      },
      {
        label: 'Amenities',
        sectionId: 'profile-amenities'
      },
      showStaff && {
        label: 'Staff',
        sectionId: 'profile-staff'
      },
      {
        label: 'Reviews',
        sectionId: 'profile-reviews'
      },
      {
        label: 'FAQs',
        sectionId: 'profile-faqs'
      }
    ].filter(Boolean) as NavigationLink[]
  }

export default generatePremiumProfileNavigationLinks
